import { render } from "./ViewArticle.vue?vue&type=template&id=3009f632&scoped=true"
import script from "./ViewArticle.vue?vue&type=script&lang=js"
export * from "./ViewArticle.vue?vue&type=script&lang=js"

import "./ViewArticle.vue?vue&type=style&index=0&id=3009f632&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3009f632"]])

export default __exports__